import { gql } from '@apollo/client'

export const GET_GENERICS_ALL = gql`
  query AllPieces(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $str: String
    $order: [GenericsGraphQlSortInput!]
    $state: StateEnumOperationFilterInput
    $productType: NullableOfInputIngredientTypeEnumOperationFilterInput
  ) {
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    productType: __type(name: "InputIngredientTypeEnum") {
      name
      enumValues {
        name
        description
      }
    }
    generic: __type(name: "GenericsGraphQl") {
      fields {
        name
        description
      }
    }

    generics(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { code: { contains: $str } }
          { name: { contains: $str } }
          { productCode: { contains: $str } }
          { productName: { contains: $str } }
          { attributeName: { contains: $str } }
          { attributeValue: { contains: $str } }
          { state: $state }
          { productType: $productType }
        ]
      }
      order: $order
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          code
          state
          name
          productType
          productId
          productCode
          productName
          attributeName
          attributeValue
          productionSystem
          carbon
          biodiversity
          eutrophication
          waterUsage
          landUse
          farming_Carbon
          farming_Biodiversity
          farming_Eutrophication
          farming_WaterUsage
          farming_LandUse
          transport_Carbon
          transport_Biodiversity
          transport_Eutrophication
          transport_WaterUsage
          transport_LandUse
          processing_Carbon
          processing_Biodiversity
          processing_Eutrophication
          processing_WaterUsage
          processing_LandUse
          packaging_Carbon
          packaging_Biodiversity
          packaging_Eutrophication
          packaging_WaterUsage
          packaging_LandUse
          storage_Carbon
          storage_Biodiversity
          storage_Eutrophication
          storage_WaterUsage
          storage_LandUse
          sale_Carbon
          sale_Biodiversity
          sale_Eutrophication
          sale_WaterUsage
          sale_LandUse
          isBom
          referenceInformation
          flag_L1_LandUseChangeCarbon
          flag_L1_LandManagementCarbon
          flag_L1_LandManagementNonCarbon
          flag_L1_NonLandCarbon
          flag_L1_UnverifiedRemovalsCarbon
          flag_L1_VerifiedRemovalsCarbon
          flag_L0_NetCarbon
          dqs_Overall
          dqs_Time
          dqs_Geography
          dqs_Reliability
          dqs_Completeness
          dqs_TechSystem
          dqs_TechCrop
          dqs_SiteEnergy
          researcherName
          researcherEmail
          userId
          userEmail
          lastUpdatedName
          updated
          lastPublishedDate
          isVerified
          verifiedOn
          verifiedByName
          verifiedByEmail
          verificationComments
        }
        cursor
      }
    }
  }
`
